import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Snackbar,
  Alert,
  Button,
} from "@mui/material";
import SalesPaymentForm from "./SalesPaymentForm";
import CancelIcon from "@mui/icons-material/Cancel";
import SaveIcon from "@mui/icons-material/Save";
import { fetchFiles } from "../redux/actions/fileActions";
import { fetchRelationships } from "../redux/actions/relationshipActions";
import CancelButton from "../components/CancelButton";
import SubmitButton from "../components/SubmitButton";
import { mediumTitle } from "../styles/typography";
import { getSalesDocuments } from "../redux/actions/salesDocumentActions";
import { listSalesPayments } from "../redux/actions/salesPaymentActions";
const buttonStyles = { margin: "0 8px" };

const SalesPaymentPopup = ({ open, onClose, popupData }) => {
  const { t } = useTranslation(['common', 'buttons', 'messages', 'pages']);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { files } = useSelector((state) => state.fileList);
  const { relationships } = useSelector((state) => state.relationshipList);
  
  const { loading, success, error } = useSelector(
    (state) => state.salesPaymentCreate
  );

  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (success) {
      setNotification({
        open: true,
        message: t('messages:success.sales_payment_created_successfully'),
        severity: "success",
      });
      dispatch({ type: "SALES_PAYMENT_CREATE_RESET" }); // Reset the success state
      dispatch(fetchFiles());
      dispatch(getSalesDocuments());
      dispatch(listSalesPayments());
      onClose();
      // window.location.reload(true);
      // navigate('/documents');
    } else if (error) {
      setNotification({
        open: true,
        message: error,
        severity: "error",
      });
      dispatch({ type: "SALES_PAYMENT_CREATE_RESET" }); // Reset the error state

    }
  }, [success, error, dispatch]);

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  useEffect(() => {
    if (open) {
      dispatch(fetchFiles());
      dispatch(fetchRelationships());
    }
  }, [dispatch, open]);

  const handleSubmit = () => {
    // Trigger form submission
    const form = document.getElementById("sales-payment-form");
    if (form) {
      form.dispatchEvent(
        new Event("submit", { cancelable: true, bubbles: true })
      );
    }
    // setTimeout(() => {
    //   window.location.reload(true);
    // }, 3000);
    
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "0", // Custom border radius
        },
      }}
    >
      <DialogTitle
        sx={{ ...mediumTitle, backgroundColor: "#0b212f", color: "#fff" }}
      >
        {t('pages:finance.register_payments')}
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: "#f9f9f9" }}>
        <SalesPaymentForm
          onClose={onClose}
          files={files}
          relationships={relationships}
          popupData={popupData}
        />
      </DialogContent>
      <DialogActions
        sx={{
          backgroundColor: "#eeeeee",

          color: "#000000",
          padding: "10px 50px",
        }}
      >
        <CancelButton variant="outlined" onClick={onClose} size="small">
          {t('buttons:secondary.cancel')}
        </CancelButton>
        <SubmitButton onClick={handleSubmit} size="small">
          {loading ? (
            <CircularProgress size={24} sx={{ color: "white" }} />
          ) : (
            t('buttons:primary.register_payment')
          )}
        </SubmitButton>
      </DialogActions>

      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default SalesPaymentPopup;